import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-1.5 text-[12px] flex-wrap min-w-0 ${className}`}
    >
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={`${item.label}-${i}`}>
            {item.href && !last ? (
              <Link
                to={item.href}
                className="text-tertiary hover:text-primary transition-colors px-1 py-0.5 -mx-1 rounded-sm hover:bg-soft truncate max-w-[180px]"
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={`${last ? 'text-primary font-medium' : 'text-tertiary'} truncate max-w-[220px]`}
                aria-current={last ? 'page' : undefined}
              >
                {item.label}
              </span>
            )}
            {!last && (
              <span aria-hidden="true" className="text-faint shrink-0">
                /
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
